<template>
    <div>
        <!-- check later -->
        <router-link v-if="$can('read-general-info', 'user')" :to="{path: `/marketing/${row.hashid}/actions/${tab}`}" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-eye"></i>
        </router-link>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
        },
        data() {
            return {
                tab: ""
            }
        },
        mounted() {
            const path = this.$route.path;

            this.tab = path.split('/').pop();
        }
    })
</script>